import React from 'react';
import PropTypes from 'prop-types';
import {Map, fromJS} from 'immutable';
import makeConstants from 'lib/makeConstants';
import createLocalStore, {localStorePropType} from 'lib/decorators/createLocalStore';
import BlockyDropdown from 'generic/BlockyDropdown/BlockyDropdown.react';
import assignmentV2ResultsUtils from './assignmentV2Results.utils';
import AssignmentResultsDetails from './AssignmentResultsDetails/AssignmentResultsDetails.react';
import Tabs from 'sg/Tabs/Tabs.react';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import AssignmentResultsStudentsList from './AssignmentResultsStudentsList/AssignmentResultsStudentsList.react';
import AssignmentResultsQuestionsList from './AssignmentResultsQuestionsList/AssignmentResultsQuestionsList.react';
import ViewWithSidebar from 'generic/ViewWithSidebar/ViewWithSidebar.react';
import './assignment-v2-results.scss';

export default class AssignmentV2Results extends React.Component {
  render() {
    if (!assignmentV2ResultsUtils.isDataReady()) {
      return (
        <ViewWithSidebar
          sidebarItems={[
            {
              label: 'Filters',
              content: <LoadingIndicator className='assignment-v2-results-filters-loader' />
            }
          ]}
          mainItems={[
            {
              label: 'Details',
              content: <LoadingIndicator />
            },
            {
              label: 'Performance',
              content: <LoadingIndicator />
            }
          ]}
        />
      );
    }
    const assignment = assignmentV2ResultsUtils.getAssignmentQuery().getResource();
    return (
      <ViewWithSidebar
        sidebarItems={[
          {
            label: 'Filters',
            content: (
              <div className='card'>
                <BlockyDropdown
                  resetStoreOnUnmount={false}
                  className='assignment-v2-results-filters-section-selector'
                  displayProperty='title'
                  data={assignment.getSortedSections()}
                  defaultValue={assignment.getSortedSections().first()}
                  storeName={assignmentV2ResultsUtils.getSectionSelectorStoreName()}
                />
              </div>
            )
          }
        ]}
        mainItems={[
          {
            label: 'Details',
            content: (
              <AssignmentResultsDetails
                assignment={assignment}
                activeSection={assignmentV2ResultsUtils.getActiveSection(assignment)}
              />
            )
          },
          {
            label: 'Performance',
            content: (
              <AssignmentResultsTableManager
                activeSectionId={assignmentV2ResultsUtils.getActiveSection(assignment).getId()}
              />
            )
          }
        ]}
      />
    );
  }
}

const tabs = makeConstants('STUDENTS', 'QUESTIONS');

@createLocalStore(
  Map({
    selected: tabs.STUDENTS
  }),
  'assignmentResultsTableManagerStore'
)
class AssignmentResultsTableManager extends React.Component {
  static propTypes = {
    setProperty: PropTypes.func,
    store: localStorePropType,
    activeSectionId: PropTypes.string
  };

  tabs = fromJS([
    {
      label: 'Students',
      onClick: () => this.props.setProperty('selected', tabs.STUDENTS),
      isActiveFunc: () => this.props.store.get('selected') === tabs.STUDENTS
    },
    {
      label: 'Questions',
      onClick: () => this.props.setProperty('selected', tabs.QUESTIONS),
      isActiveFunc: () => this.props.store.get('selected') === tabs.QUESTIONS
    }
  ]);

  getContent() {
    return this.props.store.get('selected') === tabs.STUDENTS ? (
      <AssignmentResultsStudentsList activeSectionId={this.props.activeSectionId} />
    ) : (
      <AssignmentResultsQuestionsList activeSectionId={this.props.activeSectionId} />
    );
  }

  render() {
    return (
      <Tabs className='assignment-results-table-manager' content={this.tabs}>
        <div>{this.getContent()}</div>
      </Tabs>
    );
  }
}
